import { render, staticRenderFns } from "./PermisosRol.vue?vue&type=template&id=05fe2066&scoped=true&lang=true"
import script from "./PermisosRol.vue?vue&type=script&lang=js"
export * from "./PermisosRol.vue?vue&type=script&lang=js"
import style0 from "./PermisosRol.vue?vue&type=style&index=0&id=05fe2066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe2066",
  null
  
)

export default component.exports